import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var DollarSignIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm0 2a9 9 0 100 18 9 9 0 000-18zm0 1a1 1 0 01.993.883L13 5l.001.07c2.137.31 3.784 1.612 3.993 3.59a1 1 0 11-1.988.21c-.092-.866-.857-1.53-2.006-1.77l.001 4.09c2.252.578 4 1.92 4 3.757 0 2.118-1.903 3.228-4 3.491L13 19a1 1 0 01-1.993.117L11 19v-.577c-1.94-.297-3.821-1.455-3.996-3.439a1 1 0 011.992-.176c.063.717.984 1.316 2.004 1.566v-3.65c-2.125-.67-4-2.284-4-3.958 0-2.112 1.717-3.414 4-3.704V5a1 1 0 011-1zm1.001 9.28v3.12c1.086-.218 2-.77 2-1.453 0-.587-.813-1.255-2-1.667zm-2-2.699V7.083C9.768 7.302 9 7.933 9 8.766c0 .523.884 1.316 2 1.815V7.083z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
DollarSignIcon.isCarinaIcon = true;
export default DollarSignIcon;
